var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenadzment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18125_12291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1834 7.27574C17.7759 4.33715 15.5579 1.9698 12.6955 1.33984V5.11785H7.30457V1.33988C4.44219 1.96984 2.22418 4.33719 1.81664 7.27574H0V10.4034H20V7.27574H18.1834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8261 13.529V11.5742H13.6315C13.4312 13.4014 11.8787 14.8279 9.99906 14.8279C8.11945 14.8279 6.56691 13.4014 6.36664 11.5742H1.17188V13.529H2.78531C2.90621 13.8993 3.05582 14.26 3.23289 14.608L2.09156 15.7493L5.42297 19.0807L6.56426 17.9395C6.91223 18.1165 7.27301 18.2661 7.64328 18.3871V20.0004H12.3546V18.387C12.7249 18.2661 13.0857 18.1165 13.4336 17.9395L14.5749 19.0807L17.9063 15.7492L16.765 14.608C16.9421 14.26 17.0917 13.8993 17.2126 13.5289H18.8261V13.529Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5236 0H8.47656V3.94434H11.5236V0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18125_12291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenadzment);
export default __webpack_public_path__ + "static/media/menadzment.a30802bd2ba7300421dccd5b9198457e.svg";
export { ForwardRef as ReactComponent };